import React, { forwardRef } from "react";

/**
 * RadioButton component
 * @param {Object} [props]
 * @param {string} [props.value] - Option value
 * @param {string} [props.label] - Text displayed inside button
 * @param {string} [props.selected] - Currently selected value
 * @param {function} [props.onChange] - Callback on value change
* @param {string} [props.radiusStyle] - style of button radius

 * @component
 */
export default forwardRef(
  (
    {
      value = "",
      label = "",
      selected = "",
      onChange = () => {},
      radiusStyle = "",
      ...restProps
    },
    ref
  ) => {
    const isActive = selected === value;

    return (
      <button
        ref={ref}
        type="button"
        className={[
          "RadioButton",
          isActive ? "active" : "",
          radiusStyle === "left" ? "rounded-left" : "",
          radiusStyle === "right" ? "rounded-right" : "",
        ].join(" ")}
        onClick={() => onChange(value)}
        {...restProps}
      >
        <span>{label}</span>
      </button>
    );
  }
);
